import * as types from "./comprovanteSolicitacao.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  descricao: undefined
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.SET_COMPROVANTE_SOLICITACAO:
      return state.merge({ descricao: payload });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule("comprovanteSolicitacao", reduce);
